import { render } from "./platformDetails.vue?vue&type=template&id=7d55aa5f&scoped=true"
import script from "./platformDetails.vue?vue&type=script&lang=js"
export * from "./platformDetails.vue?vue&type=script&lang=js"

import "./platformDetails.vue?vue&type=style&index=0&id=7d55aa5f&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d55aa5f"]])

export default __exports__